<template>
  <b-card
    class="h-100"
    :class="isActive ? 'card-active' : ''"
    @click="
      version !== 2
        ? $router.push({
            name: 'board.board-details-page',
            params: {
              id: board.board_id,
              name: board.site_name || $route.params.name
            }
          })
        : ''
    "
  >
    <div
      class="board-color"
      :style="
        `background: ${board.board_colour} 0% 0% no-repeat padding-box; ${
          board.board_colour === '#FFFFFF'
            ? 'box-shadow: 0px 0px 1px #0000004d;'
            : ''
        }`
      "
    ></div>

    <div class="card-details-container mt-2 ml-1">
      <div class="maintext mt-1 ellipsis">
        {{ version === 1 ? board.site_name : board.board_name }}
        <a
          v-if="board.assets && board.assets.length"
          :href="board.assets[0].url"
          target="_blank"
          @click.stop
          class="board-asset"
        >
          <img height="25px" width="25px" :src="board.assets[0].url" alt="" />
        </a>
      </div>
      <div class="subtext ellipsis">
        {{ version === 1 ? board.board_name : board.location }}
      </div>
      <div class="subtext-em style-2 mt-1 d-flex justify-content-between">
        <div class="ellipsis">{{ scannedDate }}</div>
        <div class="font-weight-bold text-primary">
          {{ board.is_new ? 'New!' : '' }}
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default {
  props: {
    board: {
      type: Object,
      required: true
    },

    version: {
      type: Number,
      default: 1
    },

    isActive: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    scannedDate() {
      return dayjs
        .utc(this.board.updated_at)
        .format('DD MMM YYYY')
        .toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  border: 0.5px solid #eaeaea;
  box-shadow: 0px 0px 2px #00000080;
  z-index: 1;
}
.board-asset {
  &:hover {
    box-shadow: 0px 0px 5px #0000004d;
  }
}
.card-active,
.card:hover {
  box-shadow: 0px 0px 30px #0000004d;
  cursor: pointer;
}
.card-body {
  padding: 16px;
}
.board-color {
  border-radius: 8px;
  height: 16px;
  margin-bottom: 10px;
}
.card-details-container {
  background-color: white;
}
.maintext {
  font-weight: bold;
  font-size: 18px;
}
.subtext {
  font-size: 16px;
}
.subtext-em {
  font-size: 16px;
  color: grey;
  font-style: italic;
}
</style>
